import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { BookOpen } from "lucide-react";

export interface CarePlanContentItemProps {
  id: string;
}

export const CarePlanContentItem = ({ id }: CarePlanContentItemProps) => {
  const contentQuery = useTellescopeQuery({
    model: "managed_content_records",
    method: "getOne",
    request: id,
    enabled: !!id,
  });

  const content = contentQuery.data;
  if (!content) return null;

  return (
    <>
      <BookOpen size={12} className="text-purple-500" />
      <p className="text-sm">{content.title}</p>
    </>
  );
};
